exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".helpSectionLink{float:right;font-size:.7em;padding-top:.5em;color:#888}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/help_section_link.scss
// module id = 1474
// module chunks = 0